<template>
    <Card :title="'配置：'+form.recommendName">
        <template #extra>
            <Button type="primary" @click="handleOpen()">添加</Button>
        </template>

        <Table :data="tableData" :columns="columns" :max-height="500" :loading="loading">
        <template #img="{row}">
            <div>
              <img v-if="row.fileUrl" :src="row.fileUrl" style="width:100%;cursor:pointer" @click="$viewerApi({images:[row.fileUrl]})" />
            </div>
        </template>
        <template #action="{row}">
            <Poptip confirm title="确定要删除吗？" transfer @on-ok="handleDel(row)"><a style="margin-left: 10px;color: red">删除</a></Poptip>
        </template>
        <template #sort="{row,index}">
                <div style="display:flex;align-items: center;">
                  <Input type="number" ref="recommendSort" v-if="tableData[index].isEdit" v-model="row.recommendSort" @on-blur="handleChangeSort(row,index)" />
                  <span v-else v-text="row.recommendSort" /> 
                  <Icon type="ios-create-outline" @click="$set(tableData, index, { ...tableData[index], isEdit:true });$nextTick(()=>{
                    $refs.recommendSort.focus()
                  })" style="font-size:15px;margin-left: 10px;cursor:pointer;color: #2d8cf0" />
                </div>
            </template>
            <Pages slot="footer" :page="page" :func="getData"></Pages>
        </Table>
        <Modal v-model="visible" title="添加短剧" :width="1000">
            <MovieAdd v-if="visible" ref="addRef" :func="getRecommendPlayNotIn" :query="{recommendId:form.id}" :selectedData="tableData.map(i=>i.playId)||[]"></MovieAdd>
            <template #footer>
                <Button @click="visible=false">取消</Button>
                <Button type="primary" :loading="submitLoading" @click="handleSubmit()">提交</Button>
            </template>
        </Modal>
    </Card>
</template>

<script>
import Pages from '@/components/pages'
import MovieAdd from '../../theater/components/movie-add.vue'
import { getRecommendPlay, addRecommendPlay, delRecommendPlay, getRecommendPlayNotIn, editRecommendPlay } from '@/api/recommend'

export default {
  components: { Pages, MovieAdd },
  props:{
    form:{
      type: Object,
      default:() => ({})
    }
  },
  data() {
    return {
      page:{
        current: 1,
        size: 10,
        total: 0
      },
      submitLoading: false,
      getRecommendPlayNotIn,
      loading: false,
      tableData: [],
      columns: [
        {
          title: '短剧id',
          key: 'playId'
        },
        {
          title: '短剧名称',
          key: 'playName'
        },
        {
          title: '短剧中文名称',
          key: 'chinesePlayName'
        },
        {
          title: '封面图',
          width: 150,
          slot: 'img'
        },
        {
          title: '排序值',
          key: 'recommendSort',
          slot: 'sort'
        },
        {
          title: '操作',
          slot: 'action'
        }
      ],
      visible:false
    }
  },
  methods:{
    getData(page) {
      if (page) this.page.current = page
      else this.page.current = 1
      this.loading = true
      getRecommendPlay({
        ...this.page,
        recommendId: this.form.id
      }).then(({ data }) => {
        this.page.total = data.total
        this.tableData = data.records
        this.loading = false
    })
    },
    handleChangeSort(row, index) {
      editRecommendPlay({ ...row }).then(r => {
        this.$Message.success('操作成功')
        this.getData(this.page.current)
      }).catch(e => {
        this.$Message.success('操作失败')
      })
      this.$set(this.tableData, index, { ...row, isEdit:false })
    },
    handleDel(row) {
      delRecommendPlay(row.id).then(r => {
        this.$Message.success('操作成功')
        this.getData()
      })
    },
    handleOpen() {
      this.visible = true
    },
    handleSubmit() {
      this.submitLoading = true
      addRecommendPlay({
        playIds: this.$refs.addRef.selection.map(i => i.playId),
        id: this.form.id
      }).then(r => {
        this.$Message.success('操作成功')
        this.submitLoading = false
        this.visible = false
        this.getData()
      }).catch(() => {
        this.submitLoading = false
        this.visible = false
      })
    }
  },
  mounted() {
    this.getData()
  }
}
</script>
